module.exports = __webpack_public_path__ + "img/img8.d31d2870.svg";